import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import user from './user/reducers';
import vendor from './vendor/reducers';
import marketplace from './marketplace/reducers';
import product from './product/reducers';
import vendorProduct from './vendorproduct/reducers';
import transaction from './transaction/reducers';
import cart from './cart/reducers';
import category from './category/reducers';
import notification from './notification/reducers';

export default history =>
  combineReducers({
    router: connectRouter(history),
    user,
    vendor,
    marketplace,
    product,
    vendorProduct,
    transaction,
    cart,
    category,
    notification
  });
